var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2778 0H9.72222C4.35279 0 0 4.47715 0 10V25C0 30.5228 4.35279 35 9.72222 35H25.2778C30.6472 35 35 30.5228 35 25V10C35 4.47715 30.6472 0 25.2778 0Z",
    fill: "#8BC24A",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7392 13.4952L16.4582 18.7771L14.0383 16.3572C13.9516 16.2705 13.8487 16.2017 13.7354 16.1548C13.6221 16.1079 13.5007 16.0837 13.3781 16.0837C13.2555 16.0837 13.134 16.1079 13.0207 16.1548C12.9075 16.2017 12.8045 16.2705 12.7178 16.3572C12.6311 16.4439 12.5623 16.5469 12.5154 16.6601C12.4685 16.7734 12.4443 16.8948 12.4443 17.0175C12.4443 17.1401 12.4685 17.2615 12.5154 17.3748C12.5623 17.4881 12.6311 17.591 12.7178 17.6777L15.798 20.7579C15.8847 20.8446 15.9876 20.9133 16.1009 20.9602C16.2142 21.0072 16.3356 21.0313 16.4582 21.0313C16.5809 21.0313 16.7023 21.0072 16.8156 20.9602C16.9288 20.9133 17.0318 20.8446 17.1185 20.7579L23.0597 14.8166C23.2349 14.6415 23.3332 14.404 23.3332 14.1564C23.3332 13.9088 23.2349 13.6713 23.0597 13.4961C22.8846 13.321 22.6471 13.2227 22.3995 13.2227C22.1519 13.2227 21.9144 13.321 21.7392 13.4961V13.4952Z",
    fill: "#8BC24A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBg);
export default __webpack_public_path__ + "static/media/success-bg.173bb3d97f2000bbbb20acb2416e78bc.svg";
export { ForwardRef as ReactComponent };